<div class="duration-container">
  <p class="duration-container__title">Not sure which dates? Choose <b> Duration</b></p>

  <div class="f-row f-center f-v-center duration-container__title">
    <span class="duration-container__input">{{durationCtrl.value}}</span>
    Days
  </div>

  <div class="f-row f-center f-v-center mt50">
    <div class="slider--before">
      5 days
    </div>
    <mat-slider  min="5" max="50">
      <input matSliderThumb [formControl]="durationCtrl" [value]="durationCtrl.value">
    </mat-slider>
    <div class="slider-after">
      50 days
    </div>
  </div>

  <p class="duration-container__title ">Popular durations:</p>

  <div class="duration-container__tile-box f-row f-center">
    @for (item of popularDurations; track item.value) {
      <div class="duration-container__tile" (click)="durationCtrl.setValue(item.value)">{{ item.label }}</div>
    }
  </div>
</div>
